/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuchRC%7Bjustify-content%3Aflex-start%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
import { useLayoutEffect, useRef } from 'react';
import { MinHeightContainer } from '../../../../common/ui/min-height-container';
const flexColumn = null;
type SearchResultsContainerProps = {
  adaptiveHeight: boolean;
  isLoadingResults: boolean;
  hasTabs?: boolean;
  children?: React.ReactNode;
};
export const SearchResultsContainer = ({
  hasTabs,
  adaptiveHeight,
  isLoadingResults,
  children
}: SearchResultsContainerProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const currentHeight: React.MutableRefObject<number | null> = useRef<number>(null);
  const fixedMinHeight = hasTabs ? '296px' : '251px';
  const adaptiveMinHeight = isLoadingResults && !!currentHeight.current ? `${currentHeight.current}px` : 'auto';
  const minheight = adaptiveHeight ? adaptiveMinHeight : fixedMinHeight;
  useLayoutEffect(() => {
    if (ref.current && adaptiveHeight && !isLoadingResults) {
      currentHeight.current = ref.current.getBoundingClientRect().height;
    }
  });
  return <MinHeightContainer ref={ref} minHeight={minheight} className={ax(["_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _39xV02N91d"])}>
			{children}
		</MinHeightContainer>;
};